import React from "react";

const LogoSvgComponent = (props) => {
  return (
    <svg
      width={638.928}
      height={141.21}
      viewBox="-69.464 4.395 638.928 141.21"
      style={{
        background: "0 0",
      }}
      preserveAspectRatio="xMidYMid"
      {...props}
    >
      <defs>
        <filter
          id="prefix__editing-crystal"
          x="-100%"
          y="-100%"
          width="300%"
          height="300%"
        >
          <feMorphology
            operator="dilate"
            radius={2}
            in="SourceGraphic"
            result="border"
          />
          <feFlood floodColor="#fff" result="black" />
          <feMorphology
            operator="dilate"
            radius={2}
            in="SourceGraphic"
            result="erode"
          />
          <feGaussianBlur in="erode" stdDeviation={4} result="blur" />
          <feOffset in="blur" dx={2} dy={2} result="offset" />
          <feComposite operator="atop" in="offset" in2="black" result="merge" />
          <feComposite
            operator="in"
            in="merge"
            in2="SourceGraphic"
            result="inner-shadow"
          />
          <feGaussianBlur
            in="SourceGraphic"
            stdDeviation={2.5}
            result="shadow1"
          />
          <feOffset in="shadow1" dy={5} result="shadow" />
          <feSpecularLighting
            in="SourceGraphic"
            result="specular"
            surfaceScale={1.5}
            specularConstant={100}
            specularExponent={10}
            lightingColor="#fff"
          >
            <fePointLight x={250} y={-300} z={-400} />
          </feSpecularLighting>
          <feGaussianBlur in="specular" stdDeviation={1} result="specular2" />
          <feComposite
            operator="in"
            in="specular2"
            in2="SourceAlpha"
            result="specular3"
          />
          <feMerge result="merge">
            <feMergeNode in="border" />
            <feMergeNode in="inner-shadow" />
            <feMergeNode in="specular3" />
          </feMerge>
          <feComponentTransfer in="merge" result="final">
            <feFuncA type="linear" slope={0.9} />
          </feComponentTransfer>
          <feMerge>
            <feMergeNode in="shadow" />
            <feMergeNode in="final" />
          </feMerge>
        </filter>
      </defs>
      <g filter="url(#prefix__editing-crystal)">
        <path
          d="M27.215 58.965h25.21v4.55h-19.39v15.29h15.75v4.55h-15.75v20.22h-5.82v-44.61zm47.55 45.19h0q-4.93 0-8.93-2.24h0q-4-2.24-6.27-6.37h0q-2.27-4.13-2.27-9.57h0q0-5.38 2.33-9.5h0q2.34-4.13 6.37-6.34h0q4.03-2.21 9.03-2.21h0q4.99 0 9.02 2.21h0q4.03 2.21 6.37 6.3h0q2.33 4.1 2.33 9.54h0q0 5.44-2.4 9.57h0q-2.4 4.13-6.49 6.37h0q-4.1 2.24-9.09 2.24h0zm0-4.93h0q3.14 0 5.89-1.51h0q2.75-1.5 4.45-4.51h0q1.69-3.01 1.69-7.23h0q0-4.22-1.66-7.2h0q-1.67-2.98-4.35-4.45h0q-2.69-1.47-5.83-1.47h0q-3.2 0-5.85 1.47h0q-2.66 1.47-4.26 4.45h0q-1.6 2.98-1.6 7.2h0q0 4.29 1.57 7.26h0q1.57 2.98 4.19 4.48h0q2.62 1.51 5.76 1.51h0zm31.49-24.07h0q1.53-3.45 4.38-5.37h0q2.85-1.92 6.95-1.92h0v6.01h-1.54 0q-9.79 0-9.79 10.63h0v19.07h-5.83v-35.07h5.83v6.65zm60.22-7.29h0q4.1 0 7.3 1.69h0q3.2 1.7 5.05 5.09h0q1.86 3.39 1.86 8.26h0v20.67h-5.76v-19.84h0q0-5.25-2.59-8.03h0q-2.59-2.79-7.01-2.79h0q-4.54 0-7.23 2.92h0q-2.69 2.91-2.69 8.41h0v19.33h-5.76v-19.84h0q0-5.25-2.59-8.03h0q-2.59-2.79-7.01-2.79h0q-4.54 0-7.23 2.92h0q-2.69 2.91-2.69 8.41h0v19.33h-5.82v-35.07h5.82v5.05h0q1.73-2.75 4.64-4.22h0q2.91-1.47 6.43-1.47h0q4.42 0 7.81 1.98h0q3.39 1.99 5.06 5.83h0q1.47-3.72 4.86-5.76h0q3.39-2.05 7.55-2.05h0zm49.03.64h5.82v35.07h-5.82v-5.18h0q-1.67 2.68-4.64 4.19h0q-2.98 1.5-6.56 1.5h0q-4.1 0-7.36-1.69h0q-3.27-1.7-5.16-5.09h0q-1.88-3.39-1.88-8.26h0v-20.54h5.76v19.77h0q0 5.19 2.62 7.97h0q2.62 2.79 7.17 2.79h0q4.67 0 7.36-2.88h0q2.69-2.88 2.69-8.39h0v-19.26zm15.68-12.29h5.82v47.36h-5.82v-47.36zm13.56 29.7h0q0-5.38 2.18-9.44h0q2.18-4.07 5.98-6.31h0q3.81-2.24 8.48-2.24h0q4.61 0 8 1.99h0q3.4 1.98 5.06 4.99h0v-6.4h5.89v35.07h-5.89v-6.53h0q-1.73 3.07-5.15 5.09h0q-3.43 2.02-7.97 2.02h0q-4.67 0-8.45-2.31h0q-3.77-2.3-5.95-6.46h0q-2.18-4.16-2.18-9.47h0zm29.7.06h0q0-3.97-1.6-6.91h0q-1.6-2.95-4.32-4.51h0q-2.72-1.57-5.98-1.57h0q-3.27 0-5.96 1.53h0q-2.68 1.54-4.28 4.48h0q-1.6 2.95-1.6 6.92h0q0 4.03 1.6 7h0q1.6 2.98 4.28 4.55h0q2.69 1.57 5.96 1.57h0q3.26 0 5.98-1.57h0q2.72-1.57 4.32-4.55h0q1.6-2.97 1.6-6.94h0zm78.14 26.05h-7.55l-8.89-8.9h0q-3.27.9-6.66.9h0q-6.21 0-11.33-2.91h0q-5.12-2.92-8.09-8.13h0q-2.98-5.22-2.98-11.75h0q0-6.52 2.98-11.74h0q2.97-5.22 8.09-8.13h0q5.12-2.91 11.33-2.91h0q6.27 0 11.39 2.91h0q5.12 2.91 8.07 8.1h0q2.94 5.18 2.94 11.77h0q0 6.4-2.82 11.52h0q-2.81 5.12-7.74 8.07h0l11.26 11.2zm-39.55-30.79h0q0 5.25 2.15 9.22h0q2.14 3.97 5.88 6.14h0q3.75 2.18 8.42 2.18h0q4.67 0 8.42-2.18h0q3.74-2.17 5.88-6.14h0q2.15-3.97 2.15-9.22h0q0-5.24-2.15-9.24h0q-2.14-4-5.88-6.15h0q-3.75-2.14-8.42-2.14h0q-4.67 0-8.42 2.14h0q-3.74 2.15-5.88 6.15h0q-2.15 4-2.15 9.24h0zm71.94-12.73h5.82v35.07h-5.82v-5.18h0q-1.67 2.68-4.64 4.19h0q-2.98 1.5-6.56 1.5h0q-4.1 0-7.36-1.69h0q-3.27-1.7-5.15-5.09h0q-1.89-3.39-1.89-8.26h0v-20.54h5.76v19.77h0q0 5.19 2.62 7.97h0q2.63 2.79 7.17 2.79h0q4.67 0 7.36-2.88h0q2.69-2.88 2.69-8.39h0v-19.26zm18.69-5.7h0q-1.67 0-2.82-1.15h0q-1.15-1.15-1.15-2.82h0q0-1.66 1.15-2.81h0q1.15-1.15 2.82-1.15h0q1.6 0 2.72 1.15h0q1.12 1.15 1.12 2.81h0q0 1.67-1.12 2.82h0q-1.12 1.15-2.72 1.15h0zm-3.01 5.7h5.82v35.07h-5.82v-35.07zm57.92-.64h0q4.09 0 7.29 1.69h0q3.2 1.7 5.06 5.09h0q1.86 3.39 1.86 8.26h0v20.67h-5.76v-19.84h0q0-5.25-2.6-8.03h0q-2.59-2.79-7-2.79h0q-4.55 0-7.24 2.92h0q-2.68 2.91-2.68 8.41h0v19.33h-5.76v-19.84h0q0-5.25-2.6-8.03h0q-2.59-2.79-7-2.79h0q-4.55 0-7.24 2.92h0q-2.68 2.91-2.68 8.41h0v19.33h-5.83v-35.07h5.83v5.05h0q1.72-2.75 4.64-4.22h0q2.91-1.47 6.43-1.47h0q4.41 0 7.81 1.98h0q3.39 1.99 5.05 5.83h0q1.47-3.72 4.87-5.76h0q3.39-2.05 7.55-2.05h0z"
          fill="#335eea"
          stroke="#88e0eb"
          strokeWidth={1.5}
        />
      </g>
      <style />
    </svg>
  );
};

export default LogoSvgComponent